export default __webpack_public_path__ + "static/banner2-3ca0649e66601a12f3f430830bafb73f.jpg";